import React from 'react';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { Loader } from 'js/components/common/Loader';
import { Games } from '../../components/Games';
import style from '../index.scss';

export const getRenderSlideCell = () => (
    value: { playableGameTypes?: string[]; isLoading?: boolean; error?: string }
): React.ReactNode => {
    const { playableGameTypes = [], isLoading, error } = value;

    if (error) {
        return <ErrorMessage className={style.errorMsg} error={error} />;
    }

    if (isLoading) {
        return <Loader className={style.loader} />;
    }

    if (!error && !isLoading && !playableGameTypes.length) {
        return null;
    }
    const selectedGames = playableGameTypes;

    return (
        <Games selectedGames={selectedGames}/>
    );
};
